window.addEventListener("load", function () {
  const body = document.querySelector("body");
  const modal = document.querySelector("#accessibility-menu");
  const accessibilityIcon = document.querySelector("#accessibility-icon");
  const closeMenuButtons = document.querySelectorAll(".close-menu");
  const clearAllButton = document.querySelector("#clear-all");
  const tools = document.querySelectorAll(".tool");

  if (!modal || !accessibilityIcon || !clearAllButton) return;

  let settings = JSON.parse(localStorage.getItem("accessibility_settings")) || {
    colorContrast: false,
    highlightLinks: false,
    textSize: 0,
    letterSpacing: 0,
    pauseAnimations: false,
    cursorSize: 0,
  };

  // --- Core Functions ---

  async function saveSettings() {
    localStorage.setItem("accessibility_settings", JSON.stringify(settings));

    try {
      const response = await fetch("", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(settings),
      });
      if (response.ok) {
        applySettings();
      }
    } catch (error) {
      console.error("Error saving settings:", error);
    }
  }

  function updateToolBackgrounds() {
    tools.forEach((tool) => {
      const setting = tool.dataset.setting;
      let isActive = settings[setting];

      if (["textSize", "letterSpacing", "cursorSize"].includes(setting)) {
        isActive = settings[setting] > 0;
      }

      tool.classList.toggle("tool-active", isActive);
      tool.classList.toggle("bg-brand-white-smoke", !isActive);
    });
  }

  function applySettings() {
    // Toggle Boolean Classes
    body.classList.toggle(
      "accessibility-color-contrast",
      settings.colorContrast,
    );
    body.classList.toggle(
      "accessibility-highlight-links",
      settings.highlightLinks,
    );
    body.classList.toggle("highlight-active", settings.highlightLinks);
    body.classList.toggle(
      "accessibility-pause-animations",
      settings.pauseAnimations,
    );

    // Animations Logic
    if (settings.pauseAnimations) {
      document.documentElement.classList.add("accessibility-pause-animations");
      document.getAnimations().forEach((anim) => anim.cancel());
      document.querySelectorAll(".animate-number").forEach((el) => {
        el.style.animation = "none";
        el.style.transition = "none";
      });
    } else {
      document.documentElement.classList.remove(
        "accessibility-pause-animations",
      );
      document.getAnimations().forEach((anim) => anim.play());
      document.querySelectorAll(".animate-number").forEach((el) => {
        el.style.animation = "";
        el.style.transition = "";
      });
    }

    // Text Size
    if (settings.textSize > 0) {
      document.documentElement.style.setProperty(
        "font-size",
        `${85 + settings.textSize * 5}%`,
        "important",
      );
    } else {
      document.documentElement.style.fontSize = "";
    }

    // Cursor Size
    body.classList.remove(
      "accessibility-cursor-size-1",
      "accessibility-cursor-size-2",
    );
    if (settings.cursorSize > 0) {
      body.classList.add(`accessibility-cursor-size-${settings.cursorSize}`);
    }

    toggleClearAllButton();
    applyLetterSpacing();
    updateToolBackgrounds();
  }

  function applyLetterSpacing() {
    body.classList.remove(
      "accessibility-letter-spacing-1",
      "accessibility-letter-spacing-2",
    );
    if (settings.letterSpacing > 0) {
      body.classList.add(
        `accessibility-letter-spacing-${settings.letterSpacing}`,
      );
    }
  }

  function toggleClearAllButton() {
    const hasActiveSettings = Object.values(settings).some(
      (val) => val !== false && val !== 0,
    );
    clearAllButton.classList.toggle("hidden", !hasActiveSettings);
  }

  function updateSettings(setting) {
    if (
      setting === "textSize" ||
      setting === "letterSpacing" ||
      setting === "cursorSize"
    ) {
      settings[setting] = (settings[setting] + 1) % 3;
    } else {
      settings[setting] = !settings[setting];
    }
    saveSettings();
  }

  // --- Event Listeners ---

  accessibilityIcon.addEventListener("click", () => {
    modal.classList.toggle("hidden");
  });

  closeMenuButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      modal.classList.add("hidden");
    });
  });

  tools.forEach((tool) => {
    tool.addEventListener("click", function () {
      updateSettings(this.dataset.setting);
    });
  });

  clearAllButton.addEventListener("click", () => {
    settings = {
      colorContrast: false,
      highlightLinks: false,
      textSize: 0,
      letterSpacing: 0,
      pauseAnimations: false,
      cursorSize: 0,
    };
    saveSettings();
  });

  // Initial Run
  applySettings();
});
